import React, { useEffect, useState } from 'react';
import { Skeleton } from 'antd';

interface DelayedSkeletonProps {
  /** Show nothing until the chunk has been loading for at least this long (ms). */
  delay?: number;
}

/**
 * Renders nothing for `delay` ms, then an animated skeleton. Used as a Suspense
 * fallback so fast / already-cached chunk loads never flash a skeleton, while
 * genuinely slow loads still get a placeholder.
 */
export const DelayedSkeleton: React.FC<DelayedSkeletonProps> = ({ delay = 250 }) => {
  const [hasElapsed, setHasElapsed] = useState(false);

  useEffect(() => {
    const timer = window.setTimeout(() => setHasElapsed(true), delay);
    return () => window.clearTimeout(timer);
  }, [delay]);

  return hasElapsed ? <Skeleton active /> : null;
};
